import type {SocialPlatform} from '@Components/social-media/social-media.types';

export interface SocialPlatformConnectGridProps {
  activePlatform: SocialPlatform | null;
  isMobileLayout: boolean;
  onPlatformCardClick: (platform: SocialPlatform) => void;
  onCancelConnection: VoidFunction;
  onAccountConnected: VoidFunction;
}

export interface UseSocialPlatformConnectOptions {
  onAccountConnected: (connectedPlatform: SocialPlatform | null, platformParams: Record<string, string>) => void;
  onConnectionBroadcast?: VoidFunction;
}

export interface UseSocialPlatformConnectResult {
  activePlatform: SocialPlatform | null;
  onPlatformCardClick: (platform: SocialPlatform) => void;
  clearActivePlatform: VoidFunction;
}

export const PLATFORM_GRID_COLUMNS = 2;

export const CENTERED_DROPDOWN_CARD_ROW_INDEX = 2;

export const FIRST_UPWARD_OPENING_CARD_ROW_INDEX = 3;
